export const formInfoinitialValues = {
  address: { answers: {} },
  social_networks: { items: [] },
  financial_activities: { items: [] },
  environment_related_activities: { items: [] },
  external_activities: { answer: {} },
  national_product_offering_activities: { items: [] },
  international_product_offering_activities: { items: [] },
  representation_activities: { items: [] },
  automation_activities: { items: [] },
  kinship_xp: { items: [] },
  pep_relationship: { items: [] },
  attorney_activities: { items: [] },
  third_party_investments: { investments_out_of_xp: {} },
  court_lawsuit_cvm_bacen_sfn: { items: [] },
  environmental_court_lawsuit: { items: [] },
  criminal_court_lawsuit: { items: [] },
  negative_media: { items: [] },
  restrictive_list: { items: [] },
  relation_with_another_companies: { items: [] },
  terms_agreement: { answer: {} },
}
